import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

import { deepResearchApi } from "./deepResearch.api";
import { PinnedFact } from "./schema";

interface DeepResearchState {
	/**
	 * Pinned facts bucketed by the prospect they were requested for. A single
	 * bucket would go stale the moment the user returns to a lead whose entry is
	 * still cached: RTK Query serves it without re-dispatching `fulfilled`, so
	 * the reducer never runs and the panel would keep rendering the previously
	 * fetched lead's pins.
	 */
	pinnedFactsByProspectId: Record<number, PinnedFact[]>;
}

const initialState: DeepResearchState = {
	pinnedFactsByProspectId: {},
};

export const deepResearchSlice = createSlice({
	name: "deepResearch",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addMatcher(
			deepResearchApi.endpoints.getPinnedFacts.matchFulfilled,
			(state, { payload, meta }) => {
				// File the payload under the prospect it was requested for — a response
				// can land after the user has already opened a different lead.
				state.pinnedFactsByProspectId[meta.arg.originalArgs] = payload;
			}
		);
	},
});

export const selectPinnedFacts = (state: RootState, prospectId?: number): PinnedFact[] =>
	prospectId ? (state.deepResearch.pinnedFactsByProspectId[prospectId] ?? []) : [];

export const deepResearchReducer = deepResearchSlice.reducer;
